"use client";

import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import TestimonialSkeleton from "./_skeletons/TestimonialSkeleton";
import Image from "next/image";
import Slider from "react-slick";
import { useRef } from "react";
import { motion } from "framer-motion";

export const Testimonial = () => {
  const { trans } = useUtility();
  const sliderRef = useRef(null);
  const { content, elements, loading } = useSection("testimonial");

  const settings = {
    arrows: false,
    dots: false,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 1,
    speed: 20000,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    pauseOnFocus: true,
    infinite: true,
  };

  if (loading) {
    return <TestimonialSkeleton />;
  }

  return (
    <section className="testimonial-section pt-100 pb-60 section-bg">
      <div className="container">
        {/* Section Heading */}
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="section-heading text-center">
              <span className="section-heading__subtitle">
                {trans(content?.subheading)}
              </span>
              <motion.h2
                className="section-heading__title gradient-text mb-0"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                {trans(content?.heading)}
              </motion.h2>
            </div>
          </div>
        </div>

        {/* Testimonial Items */}
        <div
          className="row justify-content-center testimonial-item-wrapper"
          onMouseOver={() => {
            sliderRef.current?.slickPause();
          }}
          onMouseLeave={() => {
            sliderRef.current?.slickPlay();
          }}
        >
          <div className="col-xl-10">
            <Slider
              {...settings}
              ref={sliderRef}
              className="testimonial-grid-slider"
            >
              <div className="row testimonial_grid">
                {elements?.map((item, index) => {
                  // Avatar image URL
                  const avatarUrl = item?.avatar
                    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/testimonial/${item.avatar}`
                    : `${process.env.NEXT_PUBLIC_API_URL}/assets/images/avatar.png`; // Default avatar fallback

                  return (
                    <div
                      key={index}
                      className="col-lg-4 col-sm-6 col-xsm-6 testimonial_shaff_item"
                    >
                      <div className="testimonial-item">
                        <p className="testimonial-item__desc">
                          {trans(item?.review)}
                        </p>
                        <div className="testimonial-item__author">
                          <span className="testimonial-item__author-thumb">
                            <Image
                              src={avatarUrl}
                              alt={item?.name || "User"}
                              width={42}
                              height={42}
                            />
                          </span>
                          <div className="testimonial-item__author-content">
                            <h6 className="testimonial-item__author-name">
                              {trans(item?.name)}
                            </h6>
                            <p className="testimonial-item__author-username">
                              @{trans(item?.username)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="row testimonial_grid">
                {elements?.map((item, index) => {
                  // Avatar image URL
                  const avatarUrl = item?.avatar
                    ? `${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/testimonial/${item.avatar}`
                    : `${process.env.NEXT_PUBLIC_API_URL}/assets/images/avatar.png`; // Default avatar fallback

                  return (
                    <div
                      key={index}
                      className="col-lg-4 col-sm-6 col-xsm-6 testimonial_shaff_item"
                    >
                      <div className="testimonial-item">
                        <p className="testimonial-item__desc">
                          {trans(item?.review)}
                        </p>
                        <div className="testimonial-item__author">
                          <span className="testimonial-item__author-thumb">
                            <Image
                              src={avatarUrl}
                              alt={item?.name || "User"}
                              width={42}
                              height={42}
                            />
                          </span>
                          <div className="testimonial-item__author-content">
                            <h6 className="testimonial-item__author-name">
                              {trans(item?.name)}
                            </h6>
                            <p className="testimonial-item__author-username">
                              @{trans(item?.username)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};
